import { render, staticRenderFns } from "./AddPotentialClient.vue?vue&type=template&id=a838bb02&scoped=true"
import script from "./AddPotentialClient.vue?vue&type=script&lang=js"
export * from "./AddPotentialClient.vue?vue&type=script&lang=js"
import style0 from "./AddPotentialClient.vue?vue&type=style&index=0&id=a838bb02&prod&scoped=true&lang=scss"
import style1 from "./AddPotentialClient.vue?vue&type=style&index=1&id=a838bb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a838bb02",
  null
  
)

export default component.exports